import React from 'react';
import { ReferenceField, TextField } from 'react-admin';


export const CommodityField = (props) => (
	<ReferenceField 
		link={false}
		{...props} 
		reference="commodities" 
		filter={{ is_deleted: false, no_range: true }} 
		sort={{ field: 'name', order: 'ASC' }}
		allowEmpty
	>
		<TextField source="name" />
	</ReferenceField>
);
